<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat brand' | translate" route-name="brandNew"></add-button>
      <h1 v-translate>Brandy</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <div class="field_right" v-if="$_readActionAllowedAllOrOwnAndGlobal">
          <p class="field checkbox_label" v-translate>Párovat vše</p>
          <div class="field checkboxes">
            <filter-checkbox
                id="allowPairOnStaticBrands"
                name="allowPairOnStaticBrands"
                val="allowPairOnStaticBrands"
                v-model="formFields.allowPairOnStaticBrands"
            >
              <translate class="translate">Ano</translate>
            </filter-checkbox>
            <filter-checkbox
                id="disallowPairOnStaticBrands"
                name="disallowPairOnStaticBrands"
                val="disallowPairOnStaticBrands"
                v-model="formFields.disallowPairOnStaticBrands"
            >
              <translate class="translate">Ne</translate>
            </filter-checkbox>
          </div>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
           :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="brands-list">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"/>
              <sorting-table-title
                  v-for="title in brandsTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>

            <brand-row
                v-for="entity in entities"
                :entity="entity"
                :key="entity.id"
                :selectedEntities="selectedEntities"
                @input="select"
                @deleteBrand="deleteEntity"
                :ref="'brand-row-ref-'+entity.id"
            ></brand-row>
            <tr v-if="entities.length === 0">
                 <td colspan="8">{{ $gettext('Nebyly nalezeny žádné brandy.') }}</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="brands-list"
          @limit="setLimit"
          @offset="setOffset"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import BrandRow from "@/components/views/brands/BrandRow"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "BrandsList",
  components: {
    BrandRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'brands',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'asc',
        },
        allowPairOnStaticBrands: null,
        disallowPairOnStaticBrands: null
      }
    }
  },
  created(BrandService) {
    this.entityService = BrandService
    this.createdInit()
  },
  computed: {
    brandsTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název'), column: 'sName'},
        {key: 2, name: this.$gettext('Kód'), column: 'sCode'},
        {key: 3, name: this.$gettext('Párovat vše'), column: 'fAllowPairDevicesFromOtherBrandsWhenStaticBrandConfigured'},
        {key: 4, name: this.$gettext('Počet operátorů'), column: 'sOperatorsCount'},
        {key: 5, name: this.$gettext('Počet domén'), column: 'sDomainsCount'},
        {key: 6, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.brandsTableTitles);
      headers.allow_pair_devices_from_other_brands_when_static_brand_configured.callback = entity => { return entity.allow_pair_devices_from_other_brands_when_static_brand_configured ? this.$gettext('Ano') : this.$gettext('Ne'); };
      headers.operators_count.callback = entity => { return entity.operators.length; };
      headers.domains_count.callback = entity => { return entity.domains.length; };

      return headers;
    },
  },
  methods: {
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
          if (message === "Unable to delete brand assigned to operator.") {
            errorMessage = this.$gettext("Brand nelze smazat - je přiřazen operátorům.");
          } else {
            errorMessage = message;
          }
      }.bind(this))

      return errorMessage || error['error_message'];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/BrandsList.vue